/**
 * Action types for lsyncd functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of lsyncd.
 */

// Get lsyncd constants
export const LSYNCD_REQUEST_GET = 'LSYNCD_REQUEST_GET';
export const LSYNCD_RESPONSE_GET_SUCCESS = 'LSYNCD_RESPONSE_GET_SUCCESS';
export const LSYNCD_RESPONSE_GET_FAIL = 'LSYNCD_RESPONSE_GET_FAIL'
